<template>
  <div>

    <h2>{{ $t('title.' + action + '.mobile-group') }}</h2>

    <el-row :gutter="40">

      <el-col :span="24" :md="18" :lg="12">

        <data-form
          model="mobile-groups"
          :entity="mobileGroup"
          :fields="fields"
           :beforeSubmit="beforeSubmit"
          :after-submit="afterSubmit">

          <h4>{{ $t('related-mobiles') }}</h4>

          <data-table
            model="mobiles"
            :columns="['contact_name', 'contact_refid']"
            :isSelected="isMobileSelected"
            @selection-change="mobileSelectChanged"
          />

            </data-form>

        </el-col>

    </el-row>

  </div>
</template>

<script>
export default {
  name: 'mobile-group-details',
  data () {
    return {
      newRelatedMobileIds: [],
      fields: {
        'name': {
          type: 'text',
          rules: [{ required: true }, { max: 80 }]
        },
        'description': {
          type: 'textarea',
          rules: [{ required: true }, { max: 80 }]
        }
      }
    }
  },
  computed: {
    mobileGroup () {
      const id = this.$route.params.id

      if (id === 'new') {
        return { new: true, relatedMobileIds: [] }
      }

      return this.$store.getters['mobile-groups/findById'](id, this.$store.dispatch)
    },
    action () {
      return this.mobileGroup.new ? 'create' : 'edit'
    }
  },
  methods: {
    beforeSubmit (model) {
      model.newRelatedMobileIds = this.newRelatedMobileIds
    },
    afterSubmit () {
      this.$router.back()
    },
    isMobileSelected (mobile) {
      return (this.mobileGroup.relatedMobileIds || []).includes(mobile.id)
    },
    mobileSelectChanged (selectedMobiles) {
      this.newRelatedMobileIds = selectedMobiles.map(c => c.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// MobileGroupDetails.vue?e3742c04